import { Icon as MdiIcon } from '@mdi/react';
import { mdiFileDocumentAlert, mdiFileDocumentArrowRight, mdiFileDocumentCheck, mdiReceiptTextPlus } from '@mdi/js';
import React from 'react';

const makeIconComponent = (path) => {
  return React.memo(function IconComponent({ size = 1, ...iconArgs }) {
    return <MdiIcon size={size} {...iconArgs} path={path}/>;
  });
};

export const FileDocumentArrowRight = makeIconComponent(mdiFileDocumentArrowRight);
export const FileDocumentAlert = makeIconComponent(mdiFileDocumentAlert);
export const FileDocumentCheck = makeIconComponent(mdiFileDocumentCheck);
export const ReceiptTextPlus = makeIconComponent(mdiReceiptTextPlus);
